import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'telio-terms',
  templateUrl: './terms.component.html',
  styleUrls: ['./terms.component.scss']
})
export class TermsComponent implements OnInit {

  supportEmail = environment.branding.footer.supportEmail;
  
  constructor() { }

  ngOnInit(): void {
  }

}
